import {ModalBody, ModalHeader, ModalTitle} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import stye from "../CardsModal.module.css"
import {useEffect, useState} from "react";
import ZoomImage from "../ZoomImage";
import {stackPrefix, stackNumberOfCards, stackTitles, fileExtension} from "./MetaphoricCardStacksData";
import SelectedCard from "./SelectedCard";
import {metaphoricCardAuthors} from "./DefaultMetaphoricCards";
import {useTranslation} from "react-i18next";

function MetaphoricCardsModalStartPage(props) {
    let deckLinkPrefix = stackPrefix + props.selectedStack
    const [defaultCard, setDefaultCard] = useState(stackTitles.get(props.selectedStack))
    const [selectionDone, setSelectionDone] = useState(false)
    const [card1, setCard1] = useState(defaultCard)
    const [card1Selected, setCard1Selected] = useState(false)
    const [card2, setCard2] = useState(defaultCard)
    const [card2Selected, setCard2Selected] = useState(false)
    const [card3, setCard3] = useState(defaultCard)
    const [card3Selected, setCard3Selected] = useState(false)
    const { t,i18n } = useTranslation('translation', { keyPrefix: 'startNewPage' })
    const max = stackNumberOfCards.get(props.selectedStack)
    const min = 1

    function selectCard1() {
        setCard1(getCard)
        setCard1Selected(true)
        setSelectionDone(true)
    }

    function selectCard2() {
        setCard2(getCard)
        setCard2Selected(true)
        setSelectionDone(true)
    }

    function selectCard3() {
        setCard3(getCard)
        setCard3Selected(true)
        setSelectionDone(true)
    }


    function getCard() {
        let num = Math.floor(Math.random() * (max - min + 1)) + min
        return deckLinkPrefix + "/" + num + fileExtension
    }

    let cardSelectedElement = (cardLink, className) => {
        let name = i18n.language === "en" ? metaphoricCardAuthors[props.selectedStack].name_en
            : metaphoricCardAuthors[props.selectedStack].name
        return (
            <SelectedCard
                selectedCardClassName={className}
                selectedCardlink={cardLink}
                selectedStackData={
                    {
                        author_link: metaphoricCardAuthors[props.selectedStack].link,
                        author_name_ua: metaphoricCardAuthors[props.selectedStack].name,
                        author_name_en: metaphoricCardAuthors[props.selectedStack].name_en,
                        author_name: name,
                        deck_id:props.selectedStack
                    }
                }
            />
        )
    }

    let cardElement = (cardLink, doOnClick) => {
        return (<img src={cardLink}
                     onClick={doOnClick}
                     className={selectionDone ? stye.cardNotSelected : stye.cardsDefaultBorder}
                     alt={"Not found"}
                     onContextMenu={(evt) => {evt.preventDefault()}}
                     onDragStart={(event) => {
                         event.preventDefault()
                         return false
                     }}
        />)
    }

    let card1Element = () => {
        return (
            (selectionDone && card1Selected)
                ?
                <ZoomImage image={
                    cardSelectedElement(card1, "first")
                }></ZoomImage>
                :
                cardElement(card1, selectCard1)
        )
    }

    let card2Element = () => {
        return (
            (selectionDone && card2Selected)
                ?
                <ZoomImage image={
                    cardSelectedElement(card2, "second")
                }></ZoomImage>
                :
                cardElement(card2, selectCard2)
        )
    }

    let card3Element = () => {
        return (
            (selectionDone && card3Selected)
                ?
                <ZoomImage image={
                    cardSelectedElement(card3, "third")
                }></ZoomImage>
                :
                cardElement(card3, selectCard3)
        )
    }

    useEffect(() => {
        let selectedStack = stackTitles.get(props.selectedStack)
        setDefaultCard(selectedStack)
        setCard1(selectedStack)
        setCard2(selectedStack)
        setCard3(selectedStack)
        deckLinkPrefix = stackPrefix + props.selectedStack
    }, [props.selectedStack])

    return (
        <>
            <Modal
                style={{marginTop: "30px"}}
                show={true}
                onHide={props.closeModal}
            >
                <ModalHeader closeButton>
                    <ModalTitle>{t('metaphoricCardModal')}</ModalTitle>
                </ModalHeader>

                <ModalBody>
                    <div className={stye.cardsModal}>
                        {card1Element()}
                        {card2Element()}
                        {card3Element()}
                    </div>

                </ModalBody>
            </Modal>
        </>
    )
}

export default MetaphoricCardsModalStartPage